import { Injectable } from '@angular/core';

@Injectable()
export class UtilitiesService {

  getPaymentMethod(method) {
    switch(method) {
      case 'bpay':
        return 'BPAY';
      case 'direct':
        return 'Direct Debit';
      case 'card':
        return 'Credit Card';
      case 'instant':
        return 'Instant Credit Card';
      default:
        return 'Adhoc';
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/core/data/utils/utilities.service.ts